export function LiquorData(k8sApi) {
    var apiData = {
        text: 'Kubernetes API Reference Docs - v1.29',
        children: [],
        data: {
            type: 'array'
        },
        state: {
            expanded: true,
        }
    }
    var baseTypes = ['string', 'boolean', 'integer', 'object']

    for (var i = 0; i < k8sApi.topLevel.length; i++) {
        var key = k8sApi.topLevel[i]
        if (k8sApi.types[key]) {
            apiData.children.push(initDataById(key, 0))
        }
    }

    function initDataById(id, level) {
        var api = k8sApi.types[id]
        var obj = {
            text: api.name,
            data: {...api, type: 'object'}
        }
        if (level > 0) {
            obj.data.objectKey = api.name
        }
        if (api && api.fields) {
            obj.children = []
            for (var i = 0; i < api.fields.length; i++) {
                var field = api.fields[i]
                if (
                    field.typeRefId &&
                    field.typeRefId != id &&
                    k8sApi.types[field.typeRefId] &&
                    baseTypes.indexOf(field.typeRefId) < 0
                ) {
                    if (level < 20) {
                        var child = initDataById(field.typeRefId, level + 1)
                        child.text = field.name
                        child.data.array = field.array
                        obj.children.push(child)
                    } else {
                        obj.children.push({
                            text: field.name + 'Too Deep!!!',
                            data: {
                                ...field,
                                type: field.typeRefId,
                                objectKey: field.typeRefId
                            }
                        })
                    }
                } else {
                    obj.children.push({
                        text: field.name,
                        data: {
                            ...field,
                            version: api.version,
                            kind: api.kind,
                            type: field.typeRefId,
                            objectKey: field.typeRefId
                        }
                    })
                }
            }
        }
        return obj
    }
    return apiData
}
